import { ProprietaryOpenPolicy } from './open-proprietary-policies.model';

export class OpenProprietaryPolicy {
    static readonly type = '[OpenProprietaryPolicies] Open Policy';
    constructor(public policy: ProprietaryOpenPolicy) { }
}

export class CloseProprietaryPolicy {
    static readonly type = '[OpenProprietaryPolicies] Close Policy';
    constructor(public contractId: string) { }
}

export class SetProprietaryPolicyDirty {
    static readonly type = '[OpenProprietaryPolicies] Set Dirty';
    constructor(public contractId: string, public dirty: boolean) { }
}
